/**
 * The PayNow code this device is waiting on. The intent's client secret
 * is what proves the payment page may see the code, so it stays here on
 * the device and never in a URL, where analytics, history and referrers
 * would carry it away.
 */

const KEY = "vysg-paynow-pending";

export interface PendingPayNow {
  paymentIntentId: string;
  clientSecret: string;
}

// oxlint-disable-next-line anti-slop/no-unknown-parameters -- type predicate: this IS the parse boundary for the stored JSON
function isPending(value: unknown): value is PendingPayNow {
  return (
    typeof value === "object" &&
    value !== null &&
    "paymentIntentId" in value &&
    typeof value.paymentIntentId === "string" &&
    "clientSecret" in value &&
    typeof value.clientSecret === "string"
  );
}

export function savePendingPayNow(pending: PendingPayNow): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(pending));
  } catch {
    // storage unavailable; the page still works for this visit
  }
}

export function pendingPayNow(): PendingPayNow | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    return isPending(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function clearPendingPayNow(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
